import type { WidgetDefinition } from "@nexus/widget-sdk";
import { manifest, Component, defaultConfig } from ".";

export const definition: WidgetDefinition = {
  id: "event-protection",
  module: { manifest, Component, defaultConfig },
  catalog: {
    description: "Summarize protection coverage for an event.",
    domain: "campaigns",
    visual: "Status grid",
    purposes: ["live"],
    audiences: ["analyst", "client"],
  },
  layout: { kind: "table", skeleton: "table" },
  defaultLayoutClassName: "col-span-12",
};
